// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3vVMc","buttons":"PendingPaymentAlert_buttons__1pc-H"};